












































































































































































import { Component, Vue, Emit, Prop } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'
import EventBus from '@/plugins/EventBus'

@Component

export default class ComponentModalAlterarCotacao extends Vue {
  al: boolean = false
  altCotacao: boolean = false

  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  get alert() {
    return this.al
  }

  set alert(value: boolean) {
    this.al = value
  }

  get alterarCotacaoLoading() {
    return this.altCotacao
  }

  set alterarCotacaoLoading(value: boolean) {
    this.altCotacao = value
  }

  get showModalAlterarCotacao() {
    return this.getBackofficeGlobalStore.modal.alterarCotacao
  }

  set showModalAlterarCotacao(value: boolean) {
    if (value === false) {
      this.getBackofficeGlobalStore.clearSolicitacao()
      this.alert = false
    }
    this.getBackofficeGlobalStore.setModal({ name: 'alterarCotacao', value })
  }

  get faturamento() {
    return this.getBackofficeGlobalStore.solicitacao.cotacaoOperadorasExtraGrupo
      ? this.getBackofficeGlobalStore.solicitacao.cotacaoOperadorasExtraGrupo.faturamentoDiretoComOperadora
      : false
  }

  set faturamento(value: boolean) {
    this.getBackofficeGlobalStore.setCotacaoOperadorasExtraGrupoFaturamento(value)
  }

  get notaFiscal() {
    return this.getBackofficeGlobalStore.solicitacao.cotacaoOperadorasExtraGrupo
      ? this.getBackofficeGlobalStore.solicitacao.cotacaoOperadorasExtraGrupo.notaFiscal
      : false
  }

  set notaFiscal(value: boolean) {
    this.getBackofficeGlobalStore.setCotacaoOperadorasExtraGrupoNotaFiscal(value)
  }

  get observacao() {
    return this.getBackofficeGlobalStore.solicitacao.cotacaoOperadorasExtraGrupo
      ? this.getBackofficeGlobalStore.solicitacao.cotacaoOperadorasExtraGrupo.observacao
      : 'Outros'
  }

  set observacao(value: string) {
    this.getBackofficeGlobalStore.setCotacaoOperadorasExtraGrupoObservacao(value)
  }

  get cotacaoComUrgencia() {
    return this.getBackofficeGlobalStore.solicitacao.cotacaoOperadorasExtraGrupo
      ? this.getBackofficeGlobalStore.solicitacao.cotacaoOperadorasExtraGrupo.cotacaoComUrgencia
      : false
  }

  set cotacaoComUrgencia(value: boolean) {
    this.getBackofficeGlobalStore.setCotacaoOperadorasExtraGrupoCotacaoComUrgencia(value)
  }

  get valor() {
    if (this.getBackofficeGlobalStore.solicitacao.cotacaoOperadorasExtraGrupo) {
      return this.getBackofficeGlobalStore.solicitacao.cotacaoOperadorasExtraGrupo.valor === null ? 0 : this.getBackofficeGlobalStore.solicitacao.cotacaoOperadorasExtraGrupo.valor
    }
    return 0
  }

  set valor(value: string | number | null) {
    this.getBackofficeGlobalStore.setCotacaoOperadorasExtraGrupoValor(value)
  }

  async autorizacaoAlteraCotacaoExtraGrupo() {
    this.alterarCotacaoLoading = true
    const request = await this.getBackofficeGlobalStore.autorizacaoAlteraCotacaoExtraGrupo()

    if (request === false) {
      this.alert = true
    } else {
      this.showModalAlterarCotacao = false
      EventBus.$emit('setSnackbar', { show: true, text: 'Cotação atualizada com sucesso!', icon: 'done', color: '#2E7D32' })
    }

    this.alterarCotacaoLoading = false
  }
}
